import React, { useState } from 'react';
import RadioField from '../Form/components/RadioField';
import CheckboxField from '../Form/components/CheckboxField';
import GDPRConsentText from './GDPRConsentText';
import FormGroup from '../Form/components/FormGroup';
import Label from '../Form/components/Label';
import Heading from '../Typography/Heading';

import './index.less';

const YesNoValues = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

const acceptDataText = 'I have read and understand the above';

/**
 *
 * @param {{
 * gdpr?:{inGDPRCountry:boolean|null; gdprReadConsent:boolean|null;};
 * onChange?(fieldName:string, state:boolean):void;
 * }} props
 * @returns {React.ReactElement}
 */
export const GDPR = (props) => {
  const { gdpr, onChange } = props;
  const [inGDPRCountry, setInGDPRCountry] = useState(!!gdpr?.inGDPRCountry);

  /**
   *
   * @param {string} name
   * @param {string} optionValue
   * @returns
   */
  const handleYesNoChangeOption = (name, optionValue) => {
    setInGDPRCountry(optionValue === 'yes');
    onChange?.('inGDPRCountry', optionValue === 'yes');
  }

  /**
   *
   * @param {string} name
   * @param {boolean} status
   */
  const handleGDPRAgreement = (name, status) => {
    onChange?.('gdprReadConsent', status);
  }

  const questionBlock = () => {
    return (
      <div className={'gdpr-block-questions'} tabIndex={0} role="alert" hidden={!inGDPRCountry}>
        <Label required text={<>To use Letters by Liaison from within the EU,{' '}<b>you must agree to the following</b>:</>} />
        <GDPRConsentText />
        <FormGroup
          required={inGDPRCountry}
          controlRender={({ id }) => <CheckboxField
            label={<b>{acceptDataText}</b>}
            title={acceptDataText}
            id={id}
            name={'gdprReadConsent'}
            checked={!!gdpr?.gdprReadConsent}
            onChange={handleGDPRAgreement}
            required={inGDPRCountry}
            customErrorPrefix='Entry'
          />}
        />
      </div>
    );
  }

  return (
    <div className={'gdpr-block'}>
      <Heading bold level={4} asSpan>European Union Data Protections</Heading>
      <Label className='pre-info'>
        The European Union General Data Protection Regulation (GDPR), effective May 25, 2018, governs the sharing of data by
        European residents. &nbsp;
        <a
          href="https://www.liaisonedu.com/gdpr-faq/"
          target="_blank"
          aria-label="The European Union General Data Protection Regulation (GDPR),
              effective May 25, 2018, governs the sharing of data by European residents. Learn more"
          rel="noreferrer"
        >
          Learn more
        </a>.
      </Label>
      <FormGroup
        required
        label={`Are you currently located in a European Union country, Iceland, Liechtenstein, Norway, or Switzerland?`}
        horizontal
        labelSize={12}
        labelNoHtmlfor
        controlRender={params => <RadioField
          name={'inGDPRCountry'}
          selectedOptionValue={typeof gdpr?.inGDPRCountry === 'string' ? (inGDPRCountry ? 'yes' : 'no') : undefined}
          onChange={handleYesNoChangeOption}
          classNameWrapper={'mt-2'}
          options={YesNoValues}
          {...params}
        />}
      />
      {questionBlock()}
    </div >
  );

}

export default GDPR;
